
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/[cartUrl]/presto-perks",
      function () {
        return require("private-next-pages/store/[cartUrl]/presto-perks.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/[cartUrl]/presto-perks"])
      });
    }
  